import {partnersReducerKey} from './types';
import {State} from '../reducer';

export default {
   isFetching: (state: State) => state[partnersReducerKey].isFetching,
};
